import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router';
import get from 'lodash/get';

import { getChecklistTaskById } from '../../../../selectors/checklist/checklistSelectors';
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import ChecklistDateNote from './ChecklistDateNote';

const mapStateToProps = (state, ownProps) => {
  const activeId = get(ownProps, 'params.id');
  const task = getChecklistTaskById(state, activeId) || {};

  return {
    taskId: activeId,
    note: task.notes,
    title: task.title,
    dueAtFormatted: task.due_at && moment.utc(task.due_at).format('MMMM D, YYYY'),
    dueAt: task.due_at && moment.utc(task.due_at),
  };
};


const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (editTaskRequest) => {
    const { isCustomTask, params: { id }, submitCallback } = ownProps;
    if (isCustomTask) {
      return dispatch(checklistV2Actions.editCustomTask(editTaskRequest, id)).then(() => {
        if (submitCallback) submitCallback();

        return dispatch(checklistV2Actions.emitConfMsg());
      });
    }
    return dispatch(checklistV2Actions.editTask(editTaskRequest))
      .then(() => dispatch(checklistV2Actions.trackChecklistAction({ eventName: 'Task Edited', taskId: id })))
      .then(() => dispatch(checklistV2Actions.emitConfMsg()));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChecklistDateNote));



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDateNote/index.js